<div #popup class=" mat-dialog-edition-form" appDraggable>
    <div class="popup-header d-flex justify-content-between align-items-center">
      <h2 class="title mx-auto text-center w-100 fs-6">
        {{ 'RECORD.EDIT_DISTANCE' | translate }}
      </h2>
      <button type="button" class="btn-close ms-auto p-2" data-bs-dismiss="modal" aria-label="Close"
        (click)="onCancel()"></button>
    </div>
    <div class="popup-content">
      <form class="form"  id="ngForm">
        <div class="d-flex justify-content-between mt-4">
          <div class="row-item-width-100  input-container d-flex">
            <label class="input-label">{{ 'RECORD.DISTANCE' | translate }}</label>
            <input class="input-field" [(ngModel)]="distance" type="number" [ngModelOptions]="{standalone: true}" />
            
          </div>
        </div>
      </form>
    </div>
    <div class="popup-footer">
      <button class="secondary-button popup-secondary-button" (click)="onCancel()">{{ 'BUTTONS.CANCEL' | translate }}</button>
      <button class="primary-button popup-primary-button"  (click)="onConfirm()"type="submit">{{ 'BUTTONS.CONFIRM' | translate }}</button>
    </div>
  </div>